// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_A9K","cls2":"download_preflight-cls2_a-H download_preflight-cls1_A9K"};